/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Utils/ServiceEndpointUtils" />
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import { ServiceEndpoint, ServiceEndpointExecutionRecord } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export class ServiceEndpointUtils {

    public static getEndpointPanelDescription(endpoint: ServiceEndpoint): string {
        // TODO add delegate method in props for this
        if (endpoint && endpoint.type.toUpperCase() === EndpointConstants.ServiceEndpointTypes.AzureRM.toUpperCase()) {
            let heading: string;
            if (endpoint.authorization) {
                if (endpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.WorkloadIdentityFederation) {
                    if (endpoint.data && endpoint.data.creationMode &&
                        endpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic) {
                        heading = Resources.CreateAzureRMOidcFederationAutomaticHeading;
                    } else {
                        heading = Resources.CreateAzureRMOidcFederationManualHeading;
                    }
                } else if (endpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.ServicePrincipal) {
                    if (endpoint.data && endpoint.data.creationMode &&
                        endpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic) {
                        heading = Resources.CreateAzureRMServicePrincipalAutomaticHeading;
                    } else {
                        heading = Resources.CreateAzureRMServicePrincipalManualHeading;
                    }
                } else if (endpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.PublishProfile) {
                    heading = Resources.CreateAzureRMPublishProfileHeading;
                } else {
                    heading = Resources.CreateAzureRMManagedIdentityHeading;
                }
            }

            return heading;
        }
        return undefined;
    }

    // this logic is dependent on GetServiceEndpointExecutionRecords method implementation in ServiceEndpointExecutionHistoryController.cs
    // make sure the logic is in sync whenever this method needs to be modified.
    public static getContinuationToken(records: ServiceEndpointExecutionRecord[]): number {
        return records && records.length > 0 ? records[records.length - 1].data.id : 0;
    }
}